import './styles.css'

import { useTranslation } from 'react-i18next'

import { Button } from "@fragments";
import { IconArrowRight } from '@tabler/icons-react'

export default function BottomSubmit({ onPress }) {
    const { t } = useTranslation('settings');

    return (
        <div className='bottom-submit'>
            <small className='text'>
                {t('shared.unsavedChanges')}
            </small>
            <Button
                onClick={onPress}
                variant='contained'
                className='bottom-submit-btn'
                size='small'
                endIcon={<IconArrowRight size={18} />}
            >
                {t('common:actions.save')}
            </Button>
        </div>
    )
}
